<div class="resource-manager">
  <div class="resource-manager__header">
    <h3 class="resource-manager__title">{{ 'core.resources' | translate | uppercase }}</h3>
  </div>

  <button type="button" class="btn btn-primary btn-block" (click)="onNewResource()" data-cy="new-resource">
    <i class="ri-add-circle-line"></i>
    {{ 'button.new_resource' | translate }}
  </button>

  <div class="resource-manager__lists">
    <!-- Left: all available resources (paginated catalog) -->
    <section class="resource-manager__list">
      <h4 class="resource-manager__list-title">{{ 'title.available_resources' | translate }}</h4>

      <ts-paginated-search-header
        [searchValue]="facade.searchTerm$ | async"
        [previousTokens]="facade.previousResourceTokens$ | async"
        [lastItem]="facade.nextResourceToken$ | async"
        [length]="facade.totalCount$ | async"
        [pageSize]="facade.pageSize$ | async"
        [pageSizeOptions]="pageSizeOptions"
        [disabled]="facade.loading$ | async"
        [counting]="facade.counting$ | async"
        (searchChanged)="searchTermChanged($event)"
        (pageChange)="handlePageEvent($event)"
      ></ts-paginated-search-header>

      <ts-resources-list
        [items]="facade.availableResources$ | async"
        [columns]="leftColumns"
        [loading]="facade.loading$ | async"
        [noResources]="facade.noResources$ | async"
        (assignedToggled)="onToggleAvailable($event)"
      ></ts-resources-list>
    </section>

    <!-- Right: resources assigned to this container (paginated, no search) -->
    <section class="resource-manager__list resource-manager__list--assigned">
      <h4 class="resource-manager__list-title">{{ 'title.assigned_resources' | translate }}</h4>

      <div class="resource-manager__assigned-paginator">
        <ts-token-paginator
          [previousTokens]="facade.assignedPreviousTokens$ | async"
          [lastItem]="facade.assignedNextToken$ | async"
          [length]="facade.assignedTotalCount$ | async"
          [pageSize]="facade.assignedPageSize$ | async"
          [pageSizeOptions]="pageSizeOptions"
          [hidePageSize]="true"
          [disabled]="facade.childrenLoading$ | async"
          [counting]="facade.assignedCounting$ | async"
          (pageChange)="handleAssignedPageEvent($event)"
        ></ts-token-paginator>
      </div>

      <ts-resources-list
        [items]="facade.assignedResources$ | async"
        [columns]="rightColumns"
        [loading]="facade.childrenLoading$ | async"
        [noResources]="facade.noAssignedResources$ | async"
        emptyMessageKey="info.no_assigned_resources"
        (assignedToggled)="onUnassign($event)"
        (editClicked)="onEditAssigned($event)"
      ></ts-resources-list>
    </section>
  </div>
</div>
